module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creams"
  }, [_c('div', {
    staticClass: "creams-actions row justify-content-end"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/creams/new"
    }
  }, [_vm._v("\n      Sorte hinzufügen\n    ")])], 1), _vm._v(" "), (_vm.alert.message) ? _c('div', {
    staticClass: "creams-alert"
  }, [_c('div', {
    staticClass: "alert alert-dismissable fade show",
    class: 'alert-' + _vm.alert.type
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "creams-index table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.creams), function(cream) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_c('router-link', {
      attrs: {
        "to": '/creams/edit/' + cream.id
      }
    }, [_vm._v("\n            " + _vm._s(cream.name) + "\n          ")])], 1)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert"
    }
  }, [_c('span', [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Sorte")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33f16025"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/creams/index.vue
// module id = 114
// module chunks = 1